var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED3527;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.8,399.5c-1.6-5.5-3.8-10.4-6.7-14.7c-2.9-4.3-6.4-7.9-10.5-10.9c-4.1-3-8.8-5.3-14.1-6.9 c-5.3-1.6-11.1-2.4-17.4-2.4c-11.9,0-22.3,3-31.3,8.9c-9,5.9-16,14.5-21,25.7s-7.5,25-7.5,41.2c0,16.2,2.5,30,7.4,41.4 c4.9,11.4,11.9,20,20.9,26c9,5.9,19.7,8.9,31.9,8.9c11.1,0,20.7-2,28.6-6c7.9-4,14-9.6,18.2-16.9c4.2-7.3,6.3-15.9,6.3-25.8 l10,1.5h-60v-37h97.4v29.3c0,20.5-4.3,38-13,52.7c-8.6,14.7-20.5,25.9-35.7,33.9c-15.2,7.9-32.5,11.9-52,11.9 c-21.8,0-41-4.8-57.5-14.5c-16.5-9.7-29.4-23.4-38.6-41.2c-9.2-17.8-13.8-39-13.8-63.6c0-18.9,2.7-35.7,8.2-50.5 c5.5-14.8,13.2-27.4,23.1-37.7c9.9-10.3,21.5-18.1,34.7-23.5c13.2-5.4,27.5-8.1,42.8-8.1c13.2,0,25.5,1.9,36.8,5.7 c11.4,3.8,21.5,9.2,30.3,16.2c8.8,7,16,15.2,21.6,24.8c5.6,9.6,9.2,20.1,10.8,31.6H261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.4,324.2H400l64.1,156.4h2.7L531,324.2h60.7V557h-47.7V405.5H542l-60.2,150.3h-32.5L389,404.9h-1.9v152 h-47.7V324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M620.6,557V324.2h156.8v40.6H669.8v55.5h99.5v40.6h-99.5v55.6h108.1V557H620.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeIcon);
export default __webpack_public_path__ + "static/media/gme_icon.9b61d4a3869f68805cb98b8503480f3b.svg";
export { ForwardRef as ReactComponent };